import { useEffect } from 'react'
import React from 'react'

const PriceRedirect: React.FC = () => {
    useEffect(() => {
        window.location.href = 'https://onlinepbx.ru/cost'
    }, [])

    return null
}

export default PriceRedirect
